import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { useOrganizations } from '@cast/shared-organization-context-data-access';

const KENT_NODE_OVERLAYS_QUERY_KEY = 'kent-node-overlays';

const getNodeOverlaysQueryKey = (clusterId?: string) =>
  [KENT_NODE_OVERLAYS_QUERY_KEY, clusterId] as const;

type GetNodeOverlaysQueryArgs = {
  clusterId: string;
  enabled?: boolean;
};

export const useGetNodeOverlaysQuery = ({
  clusterId,
  enabled,
}: GetNodeOverlaysQueryArgs) => {
  const { currentOrganization } = useOrganizations();
  const organizationId = currentOrganization?.id;

  return useQuery(
    queryOptions({
      queryKey: getNodeOverlaysQueryKey(clusterId),
      queryFn: async () => {
        const { data } = await apiClient.kent.getNodeOverlays({
          organizationId: organizationId!,
          clusterId,
        });
        return data;
      },
      enabled: !!clusterId && enabled,
    })
  );
};
